// @flow
export const ROOT_ROUTE = '/';
export const VOTE_ROUTE = '/vote';
export const THANKS_ROUTE = '/thanks';
export const RESULTS_ROUTE = '/results';
export const VOTES_ENDED_ROUTE = '/votes-ended';
